import { useCallback } from 'react';
import { IRoutePermissions } from 'types/common';
import { Maybe } from 'types/types.generated';
import { useAuthUser } from './useAuthUser';

/**
 * Hook to help with route operations
 */
export const useRouteUtils = () => {
  const { authUser, hasCapability } = useAuthUser();

  /**
   * Check if user has permissions to view route
   */
  const checkRoutePermissions = useCallback(
    (routePermissions: Maybe<IRoutePermissions> | undefined) => {
      if (!authUser) {
        return false;
      }

      if (!routePermissions) {
        return true;
      }

      const { userCapabilities } = routePermissions;

      return !(userCapabilities && !hasCapability(userCapabilities));
    },
    [authUser, hasCapability]
  );

  return { checkRoutePermissions };
};
